import * as THREE from "three";
import {
  WallConnectionStart,
  WallConnectionEnd,
  WallConnectionMiddle,
} from "../types/floorplannerTypes";

const clampRatio = (value: number): number => {
  if (Number.isNaN(value)) {
    return 0;
  }
  return Math.max(0, Math.min(1, value));
};

const normalizePoint = (point: THREE.Vector2 | { x: number; y: number }): THREE.Vector2 => {
  return (point as THREE.Vector2).clone ? (point as THREE.Vector2) : new THREE.Vector2(point.x, point.y);
};

export const getConnectionRatio = (
  start: THREE.Vector2 | { x: number; y: number },
  end: THREE.Vector2 | { x: number; y: number },
  position: number,
): number => {
  const startVec = normalizePoint(start);
  const endVec = normalizePoint(end);

  if (position === WallConnectionStart) {
    return 0;
  }
  if (position === WallConnectionEnd) {
    return 1;
  }
  if (position === WallConnectionMiddle) {
    return 0.5;
  }

  const wallLength = startVec.distanceTo(endVec);
  if (wallLength <= 0) {
    return 0;
  }

  return clampRatio(position / wallLength);
};

export const getConnectionPoint = (
  start: THREE.Vector2 | { x: number; y: number },
  end: THREE.Vector2 | { x: number; y: number },
  position: number,
): THREE.Vector2 => {
  const startVec = normalizePoint(start);
  const endVec = normalizePoint(end);
  const t = getConnectionRatio(startVec, endVec, position);
  const direction = endVec.clone().sub(startVec);
  return startVec.clone().add(direction.multiplyScalar(t));
};
